import { render, staticRenderFns } from "./InsightsSummary.vue?vue&type=template&id=61e56525&scoped=true"
import script from "./InsightsSummary.vue?vue&type=script&lang=js"
export * from "./InsightsSummary.vue?vue&type=script&lang=js"
import style0 from "./InsightsSummary.vue?vue&type=style&index=0&id=61e56525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e56525",
  null
  
)

export default component.exports